import { render, staticRenderFns } from "./MppGradeRights.vue?vue&type=template&id=7517645f&scoped=true"
import script from "./MppGradeRights.vue?vue&type=script&lang=js"
export * from "./MppGradeRights.vue?vue&type=script&lang=js"
import style0 from "./MppGradeRights.vue?vue&type=style&index=0&id=7517645f&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7517645f",
  null
  
)

export default component.exports